import IconButton from "components/library/IconButton";
import { classNames, cn } from "components/library/utils/classNames";
import { MinusIcon, PlusIcon } from "@heroicons/react/outline";
import { useState } from "react";

export type Question = {
  question: string;
  answer: React.ReactNode;
  defaultOpen?: boolean;
};

export const FAQSection = ({
  title = "Frequently asked questions",
  questions,
  fullWidth = false,
}: {
  title?: string;
  questions: Question[];
  fullWidth?: boolean;
}) => {
  return (
    <div className="container-lg flex justify-center py-120 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-y-48">
        {title && (
          <div className="text-32-40 font-display font-bold text-gray-900 dark:text-white">
            {title}
          </div>
        )}

        <div
          className={cn(
            "flex  flex-col items-center divide-y divide-gray-400 dark:divide-gray-800",
            fullWidth ? "w-full" : "max-w-prose"
          )}
        >
          {questions.map((question) => (
            <FAQ key={question.question} {...question} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const FAQ = ({ question, answer, defaultOpen }: Question) => {
  const [open, setOpen] = useState(defaultOpen || false);
  return (
    <div className="w-full py-12">
      <div
        className="flex w-full cursor-pointer items-center justify-between"
        onClick={() => setOpen((open) => !open)}
      >
        <div className="text-16-24 font-bold text-gray-900 dark:text-white">
          {question}
        </div>
        <IconButton
          size={40}
          shade={"gray"}
          Icon={open ? MinusIcon : PlusIcon}
          onClick={(event) => {
            event.stopPropagation();
            return setOpen((open) => !open);
          }}
        />
      </div>
      <div
        className={classNames("overflow-hidden", open ? "my-12 h-full" : "h-0")}
      >
        <div className="text-16-26 child-a:underline child-a-hover:no-underline text-gray-800 dark:text-gray-500">
          {answer}
        </div>
      </div>
    </div>
  );
};
